import { useState, useEffect } from "react";
import { WORKFLOW_SERVICE } from "utils/constants/workflow";
import {
  useIntegrationForService,
  useCtxReferences,
  useIntegrations
} from "utils/selectors";
import groupBy from "lodash/groupBy";

export const ensureIntegrationForService = ({ service, fetchIntegration }) => {
  const [loading, setLoading] = useState(false);
  const { resource, resourceUUID } = useCtxReferences();
  const canRequest = Boolean(resource && resourceUUID);
  const integration = useIntegrationForService(service);

  useEffect(() => {
    if (canRequest && integration && !loading) {
      setLoading(true);
      fetchIntegration(
        {
          resource,
          resourceUUID,
          uuid: integration.uuid
        },
        () => setLoading(true)
      );
    }
  }, [integration, canRequest]);

  return {
    loading,
    integration
  };
};

export const useEligibleWorkflowIntegrations = () => {
  const result = {};
  const integrations = useIntegrations();
  const grouped = groupBy(integrations, "service");

  for (const service in WORKFLOW_SERVICE) {
    const serviceKey = WORKFLOW_SERVICE[service];
    result[serviceKey] = [];
    if (grouped[serviceKey] && grouped[serviceKey].length) {
      result[serviceKey] = grouped[serviceKey];
    }
  }

  return result;
};
